import { FC, useState } from 'react'
import { Switch } from 'src/components'
import { useEditConfigurationParamRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'

interface Props {
  id: number;
  name: string;
  isVisible: boolean;
  onChange: () => void;
}

export const SwitchConfigurationParam: FC<Props> = ({
  id,
  name,
  isVisible,
  onChange,
}) => {
  const addMessage = useAddPopupMessage()
  const [checked, setChecked] = useState(isVisible)
  const editConfigurationParamRequest = useEditConfigurationParamRequest({ id })
  const update = (_: any, _checked: boolean) => {
    setChecked(_checked)
    editConfigurationParamRequest.mutate(
      { value: _checked ? 'true' : 'false' },
      {
        onSuccess: () => {
          onChange()
        },
        onError: (error) => {
          addMessage({ type: 'error', text: error.message })
          setChecked(!_checked)
        },
      }
    )
  }
  return (
    <Switch
      name={`${name}-switch`}
      label={checked ? 'Yes' : 'No'}
      SwitchProps={{ checked, onChange: update }}
    />
  )
}
